export default __webpack_public_path__ + "static/media/faceBotE.e8b36011.png";